const $ = jQuery.noConflict();
import 'slick-carousel';

function AlertBar() {
	const body = document.body;
	const alertContainer = document.getElementById('e29-alert-bar');
	const headerBar = document.querySelector('.main-header');
	const alertContent = alertContainer
		? alertContainer.querySelector('.alert-bar__content')
		: false;
	const alertMessages = alertContent
		? alertContent.querySelectorAll('.alert-bar__message')
		: [];
	const currentStorage = JSON.parse(sessionStorage.getItem('e29-alert-bar'));
	const alertState = currentStorage ? currentStorage : {};
	const alertItems = alertContainer
		? alertContainer.querySelectorAll('.alert-bar__item')
		: false;

	// Initialize Slick Slider on alertContent
	if (alertMessages.length > 1) {
		$(alertContent).slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			// variableWidth: true,
			prevArrow: $('.alert-bar__count .icon-chev-left'),
			nextArrow: $('.alert-bar__count .icon-chev-right'),
		});

		// const updateContentWidth = () => {
		// 	const $currentSlide = $(alertContent).find('.slick-slide.slick-current.slick-active .alert-bar__message');
		// 	const currentSlideWidth = $currentSlide.width(); // Get the current slide's width
		// 	$(alertContent).width(currentSlideWidth); // Set the width of .alert-bar__content to match the current slide
		// };

		// Update the counter initially and on slide change
		const updateCounter = () => {
			const currentSlide = $(alertContent).slick('slickCurrentSlide') + 1;
			const totalSlides = $(alertContent).slick('getSlick').slideCount;
			const counterElement = document.querySelector(
				'.alert-bar__counter span'
			);
			counterElement.textContent = `${currentSlide} / ${totalSlides}`;
		};

		updateCounter(); // Initial update
		// updateContentWidth();

		// setTimeout(() => {
		// 	updateContentWidth();
		// }, 450);

		$(alertContent).on('afterChange', function () {
			updateCounter();
			$(alertContent).width('100%');
			// setTimeout(() => {
			// 	updateContentWidth();
			// }, 200);
			// updateContentWidth();
		});
	}

	const handleResize = (isAlert = false) => {
		const headerContainerHeight = headerBar.offsetHeight;

		if (isAlert) {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;
			body.style.setProperty(
				'--alert-bar-height',
				`${alertContainerHeight + alertContainerTop}px`
			);
			body.style.setProperty(
				'--header-bar-height',
				`${alertContainerHeight + headerContainerHeight}px`
			);
		} else {
			body.style.setProperty(
				'--header-bar-height',
				`${headerContainerHeight}px`
			);
		}
	};

	handleResize(alertContainer ? true : false);

	if (alertContainer) {
		// Attach ResizeObserver to alertContainer
		const alertObserver = new ResizeObserver(() => handleResize(true));
		alertObserver.observe(alertContainer);
	} else {
		body.style.setProperty('--alert-bar-height', `0px`);
	}

	window.addEventListener('resize', () => {
		if (alertContainer) {
			handleResize(true);
		} else {
			handleResize();
		}
	});

	//Manage viewed state
	function setStorage() {
		sessionStorage.setItem('e29-alert-bar', JSON.stringify(alertState));
	}

	if (alertItems) {
		alertItems.forEach((alertItem) => {
			const alertClose = alertItem.querySelector('.alert-bar__close');
			const alertID = alertItem.getAttribute('id');

			//Loop through local storage and determine what has been viewed
			if (currentStorage) {
				for (const item in currentStorage) {
					if (item === alertID && currentStorage[item].viewed) {
						document.getElementById(item).classList.add('viewed');
					}
					if (item === alertID && !currentStorage[item].viewed) {
						document
							.getElementById(item)
							.classList.remove('viewed');
					}
				}
			}

			//No local storage, set all to not viewed
			else {
				alertState[alertID] = { viewed: false };
				alertItem.classList.remove('viewed');
			}

			//Close alert item and set local storage
			if (alertClose) {
				alertClose.addEventListener('click', function (e) {
					e.preventDefault();
					alertItem.classList.add('viewed');
					alertState[alertID] = { viewed: true };
					setStorage();
				});
			}

			//Create local storage if it doesn't exist
			if (!currentStorage) {
				setStorage();
			}
		});
	}
}

export default AlertBar;
